(() => {
  if (customElements.get('icons-tabs')) {
    return;
  }

  class IconsTabs extends HTMLElement {
    constructor() {
      super();
      this.addEventListener('click', this.toggle.bind(this))
    }

    toggle(e) {
      const tab = e.target.closest('[data-tab]');
      if (!tab) return

      const image = this.querySelector(`[data-image][data-id="${tab.dataset.id}"]`)

      if(image) {
        this.querySelectorAll('[active]').forEach(el => {
          el.removeAttribute('active');
        });

        e.target.closest('[data-tab]').setAttribute('active', '');
        image.setAttribute('active', '');
      }
    }
  }

  customElements.define('icons-tabs', IconsTabs);
})();
